/* NEWLUNA 3.0 hero: gentle pointer depth for the layered Face & Neck mask.
   Only transform-based properties change; nothing runs with reduced motion
   or on touch devices. The entrance itself is triggered in newluna.js. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (root.classList.contains('reduce-motion')) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function init(hero) {
    if (hero.dataset.haloReady) return;
    hero.dataset.haloReady = '1';
    var product = hero.querySelector('[data-halo-product]');
    var parts = hero.querySelectorAll('.halo__part');
    var card = hero.querySelector('.halo__card');
    var raf = 0, nx = 0, ny = 0;

    function apply() {
      raf = 0;
      if (product) {
        product.style.setProperty('--px', (nx * -10).toFixed(1) + 'px');
        product.style.setProperty('--py', (ny * -8).toFixed(1) + 'px');
      }
      for (var i = 0; i < parts.length; i++) {
        parts[i].style.setProperty('--lx', (nx * -16).toFixed(1) + 'px');
        parts[i].style.setProperty('--ly', (ny * -12).toFixed(1) + 'px');
      }
      if (card) {
        card.style.setProperty('--cx', (nx * 8).toFixed(1) + 'px');
        card.style.setProperty('--cy', (ny * 6).toFixed(1) + 'px');
      }
    }
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      nx = (e.clientX - r.left) / r.width - 0.5;
      ny = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    hero.addEventListener('pointerleave', function () {
      nx = 0; ny = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.halo[data-hero]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
